import React from 'react';
import API from "../../Services/API";
import {toast} from "react-toastify";
import Toast from "../../Components/Toast";
import Loading from "../../Layouts/Loading";
import {LuClipboardList} from "react-icons/lu";
import {BsChevronLeft, BsShop} from "react-icons/bs";
import {FaCubes} from "react-icons/fa";
import {TbDoorExit, TbReportAnalytics} from "react-icons/tb";
import {useNavigate} from "react-router-dom";
import {GiHamburgerMenu} from "react-icons/gi";
import LogoPic from "../../Assets/Images/logo.png";
import {BiSolidSelectMultiple} from "react-icons/bi";
import {LiaUserEditSolid} from "react-icons/lia";
import "react-multi-date-picker/styles/layouts/mobile.css"
import DatePicker from "react-multi-date-picker"
import persian from "react-date-object/calendars/persian"
import persian_fa from "react-date-object/locales/persian_fa"

const currencyFormat = Intl.NumberFormat('en-US');
function VendorReports
() {
    const navigate = useNavigate();

    const [isLoaded, setIsLoaded] = React.useState(false);
    const [reportLoaded, setReportLoaded] = React.useState(false);
    const [user, setUser] = React.useState([]);
    const [orderCount, setOrderCount] = React.useState([]);
    const [reports, setReports] = React.useState([]);
    const [dateFrom, setDateFrom] = React.useState('');
    const [dateTo, setDateTo] = React.useState('');

    React.useEffect(() => {
        const match = document.cookie.match(new RegExp('(^| )auth=([^;]+)'));
        const token = match ? match[2] : null;
        if (!token) {
            window.location.replace('/login')
        }
        API.getUserInfo()
            .then((response) => {
                setIsLoaded(true)
                  setUser(response.data.user);
                for(let v in response.data.user.vendor) {
                    if(response.data.user.vendor[v].id === parseInt(window.localStorage.getItem("vendor"))) {
                        setOrderCount(response.data.user.vendor[v].ordersCount)
                    }
                }

            })
            .catch((error) => {
                if (error.response) {

                    toast.error(error.response.data.message);
                } else {
                    toast.error(error.message);
                }
            });


        //
        if(window.localStorage.getItem("df")) {
            const params = {
                vendor_id: window.localStorage.getItem("vendor"),
                dateFrom : window.localStorage.getItem("df") ,
                dateTo :  window.localStorage.getItem("dt") ,
            }
            API.getReport(params)
                .then((response) => {
                    setReports(response.data)
                    setIsLoaded(true)
                    setReportLoaded(true)

                })
                .catch((error) => {
                    if (error.response) {
                        toast.error(error.response.data.message);
                    } else {
                        toast.error(error.message);
                    }
                });
        }





    }, []);

    const onExitClick = () => {
        localStorage.clear();
        document.cookie = "auth=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
        window.location.replace("/")
    }

    const onLoadReport = () => {
        if(dateFrom.length < 3 || dateTo.length < 3) {
            toast.error('بازه تاریخی را انتخاب کنید');
            return false
        }

        const toMonth = dateTo?.toDate?.().getMonth() -(-1);
        const fromMonth = dateFrom?.toDate?.().getMonth() -(-1);
        const params = {
            vendor_id: window.localStorage.getItem("vendor"),
            dateFrom : dateFrom?.toDate?.().getFullYear() + '-' + fromMonth + '-' + dateFrom?.toDate?.().getDate() + ' 00:00' ,
            dateTo : dateTo?.toDate?.().getFullYear() + '-' + toMonth + '-' + dateTo?.toDate?.().getDate() + ' 23:59' ,
        }
        window.localStorage.setItem("df", params.dateFrom);
        window.localStorage.setItem("dt", params.dateTo);
        setIsLoaded(false)
        API.getReport(params)
            .then((response) => {
                setReports(response.data)
                setIsLoaded(true)
                setReportLoaded(true)

            })
            .catch((error) => {
                if (error.response) {
                    toast.error(error.response.data.message);
                } else {
                    toast.error(error.message);
                }
            });
    }
    return (
        <React.Fragment>
            <Toast/>
            {
                !isLoaded && <Loading/>
            }

            <section className="container-fluid  rtl">
                <div className="row bg-primary-color py-3 ps-0" id='menu-button'>
                    <div className="col-6 text-end "
                         onClick={() => {
                             window.document.getElementById('side-menu').style.display = 'block';
                         }}
                    >
                        <GiHamburgerMenu className='text-white fw-bold text-big-3'/>

                    </div>
                    <div className="col-6 text-start">
                        <img src={LogoPic} alt="پخش من" className="rounded " width='30'/>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-3 p-5 ">
                        <div className="row " id='side-menu'>
                            <div className="col-12">
                                <div className="row">
                                    <div className="col-12 text-center">
                                                 {
                                            isLoaded && user?.vendor?.map (vendor  => {
                                                if(vendor.id === parseInt(window.localStorage.getItem("vendor")) ) {
                                                    return (
                                                        <img src={vendor.cover_photo} alt="Cover" className='w-100 mt-3 company-cover-photo' />
                                                    )
                                                }
                                                return '';
                                            } )
                                        }
                                        <div className='text-primary-color mb-4 text-small-2 mt-3'>
                                            {user.name}
                                            &nbsp;

                                            {user.surname}
                                            &nbsp;

                                            (
                                            {
                                                window.localStorage.getItem("vendorTitle")
                                            }
                                            )

                                        </div>
                                    </div>
                                    <div className="col-12 item "
                                         onClick={() => navigate(`/home/1`)}
                                    >
                                        <LuClipboardList className='mx-2'/>
                                                    سفارش های تازه ثبت شده
                                        {
                                            orderCount > 0 &&  <span className='badge badge-pill badge-primary bg-danger mx-2 text-small-3 '>
                                                                    {orderCount}
                                                                </span>
                                        }
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>
                                    <div className="col-12 item "
                                         onClick={() => navigate(`/home/2`)}
                                    >
                                        <LuClipboardList className='mx-2'/>
                                        سفارش های جاری
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>
                                    <div className="col-12 item "
                                         onClick={() => navigate(`/home/3`)}
                                    >
                                        <LuClipboardList className='mx-2'/>
                                        سفارش های تمام شده
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>

                                    <div className="col-12 item "
                                         onClick={() => navigate(`/products`)}
                                    >
                                        <FaCubes className='mx-2'/>
                                        مدیریت کالاها
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>
                                    <div className="col-12 item "
                                         onClick={() => navigate(`/vendor/manage`)}
                                    >
                                        <BsShop className='mx-2'/>
                                        مدیریت اطلاعات مجموعه
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>
                                    <div className="col-12 item "
                                         onClick={() => navigate(`/vendor/select`)}

                                    >
                                        <BiSolidSelectMultiple className='mx-2'/>
                                        انتخاب مجموعه فعال
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>
                                    <div className="col-12 item "
                                         onClick={() => navigate(`/edit-profile`)}
                                    >
                                        <LiaUserEditSolid className='mx-2'/>
                                        ویرایش حساب کاربری
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>
                                    <div className="col-12 item "
                                         onClick={() => navigate(`/reports`)}
                                         id='active'
                                    >
                                        <TbReportAnalytics className='mx-2'/>
                                        گزارش فاکتورهای فروش
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>     <div className="col-12 item "
                                         onClick={() => navigate(`/product-reports`)}

                                    >
                                        <TbReportAnalytics className='mx-2'/>
                                        گزارش  فروش کالا
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>

                                    <div className="col-12 item "
                                         onClick={() => navigate(`/wallet`)}
                                    >
                                        <TbReportAnalytics className='mx-2'/>
                                        گزارش صورت عملکرد
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>
                                    <div className="col-12 item "
                                         onClick={onExitClick}
                                    >
                                        <TbDoorExit className='mx-2'/>
                                        خروج از حساب کاربری
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-9 pt-md-5 pb-5 ">
                        <div className="row pb-5 px-2 main-part">
                            <div className="col-12 page-title text-center pb-4 mb-5 border-bottom fw-bold text-muted">
                               گزارش فاکتورهای فروش
                                <div className='text-small-3 text-secondary mt-3 opacity-75'>
  (
                                    {
                                        window.localStorage.getItem("vendorTitle")
                                    }
                                    )
                                </div>

                            </div>
                            <div className="col-md-4 mb-3">
                                <span className='text-small-2 mx-3'>
                                    از تاریخ
                                </span>
                                <DatePicker
                                    onChange={ (val) =>{
                                        setDateFrom(val)
                                    }

                                }
                                    calendar={persian}
                                    locale={persian_fa}
                                    calendarPosition= "bottom-right"
                                    className="rmdp-mobile"

                                />
                            </div>
                            <div className="col-md-4 mb-3">
                            <span className='text-small-2 mx-3'>
                                    تا تاریخ
                                </span>
                                <DatePicker
                                    onChange={ (val) => setDateTo(val)}
                                    calendar={persian}
                                    locale={persian_fa}
                                    calendarPosition= "bottom-right"
                                    className="rmdp-mobile"

                                />
                            </div>
                            <div className="col-md-4 mb-3">
                                <button className='btn btn-primary w-100'
                                 onClick={onLoadReport}
                                >
                                    مشاهده گزارش
                                </button>
                            </div>
                            {
                                reportLoaded ?
                                    <div className="col-12">
                                        <div className="row">
                                            <div className="col-md-6 p-2">
                                                <div className="row report-box mx-1">
                                                    <div className="col-12 border-bottom pb-2 mb-3 text-center fw-bold text-secondary">
                                                        مجموع سفارش ها
                                                    </div>
                                                    <div className="col-5 text-end text-small-2 text-primary fw-bold">
                                                        {
                                                            reports.countTotal
                                                        }
                                                        &nbsp;
                                                        فاکتور
                                                    </div>
                                                    <div className="col-7 text-start text-small-1 text-success fw-bold">
                                                        {
                                                            currencyFormat.format(reports.sumTotal)
                                                        }
                                                        &nbsp;
                                                        ریال
                                                    </div>

                                                </div>
                                            </div>
                                            <div className="col-md-6 p-2">
                                                <div className="row report-box mx-1">
                                                    <div className="col-12 border-bottom pb-2 mb-3 text-center fw-bold text-secondary"
                                                         role='button'
                                                         onClick={() => navigate(`/home/1`)}
                                                    >
                                                        <BsChevronLeft className='float-start mt-1'/>
                                                        سفارش های جدید

                                                    </div>
                                                    <div className="col-5 text-end text-small-2 text-primary fw-bold">
                                                        {
                                                            reports.countNew
                                                        }
                                                        &nbsp;
                                                        فاکتور
                                                    </div>
                                                    <div className="col-7 text-start text-small-1 text-success fw-bold">
                                                        {
                                                            currencyFormat.format(reports.sumNew)
                                                        }
                                                        &nbsp;
                                                        ریال
                                                    </div>

                                                </div>
                                            </div>
                                            <div className="col-md-6 p-2">
                                                <div className="row report-box mx-1">
                                                    <div className="col-12 border-bottom pb-2 mb-3 text-center fw-bold text-secondary"
                                                         role='button'
                                                         onClick={() => navigate(`/home/2`)}
                                                    >
                                                        <BsChevronLeft className='float-start mt-1'/>
                                                        سفارش های جاری
                                                    </div>
                                                    <div className="col-5 text-end text-small-2 text-primary fw-bold">
                                                        {
                                                            reports.countCurrent
                                                        }
                                                        &nbsp;
                                                        فاکتور
                                                    </div>
                                                    <div className="col-7 text-start text-small-1 text-success fw-bold">
                                                        {
                                                            currencyFormat.format(reports.sumCurrent)
                                                        }
                                                        &nbsp;
                                                        ریال
                                                    </div>

                                                </div>
                                            </div>
                                            <div className="col-md-6 p-2">
                                                <div className="row report-box mx-1">
                                                    <div className="col-12 border-bottom pb-2 mb-3 text-center fw-bold text-secondary"
                                                         role='button'
                                                         onClick={() => navigate(`/home/3`)}
                                                    >
                                                        <BsChevronLeft className='float-start mt-3'/>
                                                        سفارش های تحویل شده
                                                    </div>
                                                    <div className="col-5 text-end text-small-2 text-primary fw-bold">
                                                        {
                                                            reports.countFinish
                                                        }
                                                        &nbsp;
                                                        فاکتور
                                                    </div>
                                                    <div className="col-7 text-start text-small-1 text-success fw-bold">
                                                        {
                                                            currencyFormat.format(reports.sumFinish)
                                                        }
                                                        &nbsp;
                                                        ریال
                                                    </div>

                                                </div>
                                            </div>
                                            <div className="col-md-6 p-2">
                                                <div className="row report-box mx-1">
                                                    <div className="col-12 border-bottom pb-2 mb-3 text-center fw-bold text-secondary"

                                                         role='button'
                                                         onClick={() => navigate(`/home/4`)}
                                                    >
                                                        <BsChevronLeft className='float-start mt-1'/>
                                                        سفارش های رد شده
                                                    </div>
                                                    <div className="col-5 text-end text-small-2 text-primary fw-bold">
                                                        {
                                                            reports.countCancel
                                                        }
                                                        &nbsp;
                                                        فاکتور
                                                    </div>
                                                    <div className="col-7 text-start text-small-1 text-success fw-bold">
                                                        {
                                                            currencyFormat.format(reports.sumCancel)
                                                        }
                                                        &nbsp;
                                                        ریال
                                                    </div>

                                                </div>
                                            </div>

                                        </div>
                                    </div> :
                                    <div className="col-12 vh-50">
                                        &nbsp;
                                        <div className="alert alert-warning text-small-2 text-center">
                                            برای مشاهده گزارش فاکتورهای فروش ابتدا بازه تاریخی مد نظر را انتخاب کرده و سپس دکمه مشاهده گزارش را بزنید
                                        </div>
                                    </div>
                            }


                        </div>

                    </div>
                </div>
            </section>
        </React.Fragment>
    );
}

export default VendorReports
;